module.exports = __webpack_public_path__ + "static/img/1.effbf52.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/11/zh/1.png
// module id = cl/i
// module chunks = 0